module.exports = __webpack_public_path__ + "static/media/2-whale-bowie.51567604.svg";